const PaeFactory = function ($resource, $window) {
    const getCheckPaeUserApi = "/participant-web-services/rest/sso/isPAEUser";
    const checkPaeUserParams = {
        individualId: "@individualId",
        groupId: "@groupId"
    };

    return {
        //This tells whether the user is a PAE user or not.
        getCheckPaeUser: $resource(__baseApiUrl__ + getCheckPaeUserApi, checkPaeUserParams, {
            query: {
                method: "GET",
                isArray: false,
                headers: {
                    "Content-Type": "application/json"
                }
            }
        })
    };
};

PaeFactory.$inject = ["$resource", "$window"];
export default PaeFactory;
